export const links = [
    {
        label: "Picklist Data",
        path: "/admin/attributes/picklist-data",
        activePaths: ["admin/attributes/picklist-data"],
    },
    {
        label: "Settings",
        path: "/admin/attributes/attribute-settings",
        activePaths: ["admin/clients/attribute-settings"],
    },
];
